<template>
  <Motion
    as="div"
    :initial="{ opacity: 0, y: 20, backgroundColor: bgColor }"
    :animate="{ opacity: 1, y: 0, backgroundColor: bgColor }"
    :whileHover="{
      scale: 1.02,
      boxShadow: '0 8px 16px rgba(0, 0, 0, 0.15)',
      filter: 'brightness(0.9)',
      transition: {
        duration: 0.3,
        ease: 'easeOut'
      }
    }"
    :transition="{
      duration: 0.5,
      backgroundColor: {
        delay: motionDelay / 1000,
      },
      opacity: {
        delay: motionDelay / 1000,
      },
      y: {
        delay: motionDelay / 1000,
      },
      ease: 'easeOut'
    }"
    class="lg:py-6 py-4 rounded-20 lg:px-5 px-4 cursor-pointer font-basic flex flex-col justify-between relative overflow-hidden"
    :style="{
      color: textColor
    }"
    @click="goToPage"
  >
    <!-- 상단: Title -->
    <div class="flex items-center justify-between">
      <p class="font-normal font-basic text-sm sm:text-lg lg:text-xl 2xl:text-[26px] tracking-tight">
        {{ title }}
      </p>
      <img
        v-if="icon"
        :src="icon"
        alt="icon"
        class="w-4 h-4 sm:w-8 sm:h-8"
      />
    </div>

    <!-- 하단: Subtitle -->
    <div>
      <p class="font-semibold font-paperlogy text-xl sm:text-3xl xl:text-4xl 2xl:text-5xl whitespace-pre-wrap">
        {{ subtitle }}
      </p>
    </div>
  </Motion>
</template>

<script setup>
import { useRouter } from 'vue-router'
import { useResponsive } from '@/composables/useResponsive'
import { Motion } from 'motion-v'

const props = defineProps({
  id: {
    type: String,
    required: true
  },
  title: {
    type: String,
    required: true
  },
  subtitle: {
    type: String,
    default: ''
  },
  route: {
    type: String,
    required: true
  },
  bgColor: {
    type: String,
    required: true
  },
  textColor: {
    type: String,
    required: true
  },
  icon: {
    type: String,
    default: ''
  },
  motionDelay: {
    type: Number,
    default: 0
  }
})

const router = useRouter()

// Responsive state
const { isMobile } = useResponsive()

const goToPage = () => {
  // route가 비어 있으면(아직 URL 미연결) 이동하지 않음
  if (!props.route) return
  // 외부 URL(http/https)이면 새 탭으로 열고, 내부 경로는 라우터 이동
  if (/^https?:\/\//.test(props.route)) {
    window.open(props.route, '_blank', 'noopener')
    return
  }
  router.push(props.route)
}
</script>
